import Vue from 'vue';

import { isEmpty } from 'lodash-es';
import { httpClient } from '@api';

import { Payout } from './payout.dto';

export default {
  list: async (params) => {
    try {
      let normalizedList = [];

      const res = await httpClient.post('bank-reconciliation/payout/list', {
        companyId: Vue.prototype.$auth.user()?.selectedCompany?.id,
        ...params,
      });

      if (params?.contentType === 'xlsx' || params?.contentType === 'csv') return res;

      const { data, total } = res;

      normalizedList = isEmpty(data) ? [] : data.map((item) => new Payout(item));

      return { data: normalizedList, total };
    } catch (error) {
      console.error(error);
    }
  },
  update: async (params) => {
    try {
      await httpClient.post('bank-reconciliation/payout/update-one', {
        companyId: Vue.prototype.$auth.user()?.selectedCompany?.id,
        ...params,
      });
    } catch (error) {
      console.error(error);
    }
  },
  findOne: async (params) => {
    try {
      const item = await httpClient.post('bank-reconciliation/payout/find-one', {
        companyId: Vue.prototype.$auth.user()?.selectedCompany?.id,
        ...params,
      });

      return new Payout(item);
    } catch (error) {
      console.error(error);
    }
  },
};
